module.exports = __webpack_public_path__ + "static/media/STANDARD_RAFFLE_FAST.2bdea0ed.mp3";